import { render, staticRenderFns } from "./SubUsersType.vue?vue&type=template&id=34b3606f&scoped=true"
import script from "./SubUsersType.vue?vue&type=script&lang=js"
export * from "./SubUsersType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3606f",
  null
  
)

export default component.exports